import { CampaignType } from '../types';
import { CampaignTypeSpec } from './policy';
import {
  annualSpec,
  awayMessageSpec,
  enrollmentSpec,
  joinSpec,
  messageSpec,
  recurringSpec,
  reminderSpec,
  textToWinSpec,
} from './types';

/**
 * Exhaustive registry of campaign behavior. Each implementation lives in its
 * own file so defaults, hydration, action issues, payload and schema for one
 * type can be reviewed together.
 */
export const campaignTypeSpecs: Record<CampaignType, CampaignTypeSpec> = {
  message: messageSpec,
  join: joinSpec,
  enrollment: enrollmentSpec,
  reminder: reminderSpec,
  annual: annualSpec,
  recurring: recurringSpec,
  away_message: awayMessageSpec,
  text_to_win: textToWinSpec,
};
